import { avcoreStreamApiCredentials } from "../avcore";
import { roomId } from "../room/room-id";
import { streamId } from "../stream";

export const roomMixerStreamEntityRaw = {
  type: "object",
  required: ["id", "roomId", "credentials"],
  properties: {
    id: streamId,
    roomId: roomId,
    credentials: avcoreStreamApiCredentials
  },
  additionalProperties: false
};
